module.exports = __webpack_public_path__ + "static/media/navidad8.06baabf9.jpg";